// extracted by mini-css-extract-plugin
var _1 = "28px";
export { _1 as "avatarSize" }
